<template>
    <transition name="accordion">
        <div class="accordion-div">
            <div class="accordion-body" :class="{ 'is-folded': is_folded }">
                <slot></slot>
            </div>
            <div class="accordion-ctrl" @click="spread" v-if="is_folded">▼</div>
            <div class="accordion-ctrl" @click="fold" v-if="! is_folded">▲</div>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'AccordionDiv',

    data () {
        return {
            is_folded: true
        };
    },

    methods: {
        spread: function() {
            this.is_folded = false;
        },

        fold: function() {
            this.is_folded = true;
        }
    }
};

</script>
